import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  callout: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    borderRadius: theme.sizes.roundCorners,
    overflow: 'hidden'
  },
  dark: {
    // Figma: Yellow_50 at 15% behind the content. The palette has no 15% yellow, so tint a layer.
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundColor: theme.colorPalette.yellow_50,
      opacity: 0.15
    },
    '& $text': {
      color: theme.onCard.white,
      lineHeight: '16px'
    }
  },
  light: {
    backgroundColor: theme.colorPalette.beige_40,
    '& $text': {
      color: theme.colorPalette.green_100,
      lineHeight: '20px'
    }
  },
  icon: {
    position: 'relative',
    flexShrink: 0,
    width: 16,
    height: 16
  },
  text: {
    position: 'relative',
    display: 'block',
    margin: 0,
    '& strong': {
      fontWeight: 600
    }
  }
}));
